angular.module('tgaApp').directive('slider', () => ({
  restrict: 'E',
  scope: {
    ngModel: '=',
    onChanged: '&',
  },
  replace: true,
  template: '<div></div>',
  require: 'ngModel',
  link(scope, element, attrs) {
    // watch the ngModel to set slider when val in ngModel var changes
    scope.$watch('ngModel', (newVal) => {
      // check when ngModel is not initialized
      if (angular.isDefined(newVal)) {
        element.slider('value', parseFloat(newVal, 10));
      }
    });

    // create jQuery UI Slider
    element.slider({
      min: parseFloat(attrs.min, 10),
      max: parseFloat(attrs.max, 10),
      step: parseFloat(attrs.step, 10),
      value: scope.ngModel,
      animate: 'fast',
      orientation: 'horizontal',
    });

    // bind the slide function to update the ngModel
    element.bind('slide', (event, ui) => {
      scope.ngModel = Math.round(ui.value);
      scope.$apply();
    });

    // execute onChanged function when slider value is changed
    // (not executed during dragging the slider)
    if ('onChanged' in attrs) {
      element.bind('slidechange', (event, ui) => {
        scope.onChanged()(ui.value);
      });
    }
  },
}));
